module.exports = __webpack_public_path__ + "media/images/logo/bio-beauty-f71b0d502f5f45d633f6b16f711d4ac7.svg";